exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n\n.k-drop-box {\n  border: 2px dashed #eaedf1;\n  background: #f9fafc;\n  width: 100%;\n  height: 150px;\n  text-align: center;\n  font-weight: 700;\n  line-height: 150px;\n  cursor: pointer;\n}\n\n\n.k-drag-over {\n  border: dashed 2px blue;\n}\n\n\n.my-drop-zone { border: dotted 3px lightgray; }\n.nv-file-over { border: dotted 3px red; } /* Default class applied to drop zones on over */\n.another-file-over-class { border: dotted 3px green; }\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/css-loader?{"sourceMap":false,"importLoaders":1}!/opt/app/develop/~/postcss-loader?{"ident":"postcss"}!/opt/app/develop/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2